import React, { } from "react";
import { Card, Stack } from "@mui/material";
import SvgDiagram from "../../SvgDiagram";

function formatInfo(value) {
    const valueStr = parseFloat(value).toFixed(1);

    return `${valueStr}kg`;
}

export default function TanitaMC780MuscleRadarCard({ data }) {
    const image = {
        // 1012 × 480
        w: 1012, h: 750,
        src: "/assets/tanita/mc780/body_muscle_mass_diagram.png"
    }

    const infos = [
        formatInfo(data.trunk_muscle_mass),
        formatInfo(data.la_muscle_mass),
        formatInfo(data.ll_muscle_mass),
        formatInfo(data.rl_muscle_mass),
        formatInfo(data.ra_muscle_mass),
    ];

    const radarValues = [
        parseInt(data.trunk_muscle_score),
        parseInt(data.la_muscle_score),
        parseInt(data.ll_muscle_score),
        parseInt(data.rl_muscle_score),
        parseInt(data.ra_muscle_score),         
    ];

    const positions = [
        [440, 130],
        [110, 320],
        [110, 570],
        [760, 570],
        [760, 320],
    ];




    const markers = [];

    const radarSetting = {
        values: radarValues, valueRange: [-4, 4],
        radarCenter: [505, 460], radarRange: [-2, 230]
    };

    markers.push(
        { type: "radar", ...radarSetting}, 
    );

    for (let i = 0; i < infos.length; i++) {
        const [x, y] = positions[i];

        markers.push({
            type: "text", x: x, y: y,
            text: infos[i], 
            fontSize: 3.5,
        });
    }
    // { type: "dot", x: x, y: y, r: 10, color: "red", origin: "bottom-left" }

    // const imageW = 711;
    // const imageH = 531;
    return <Card sx={{ maxWidth: 900 }}>
        <Stack direction="column">
            <SvgDiagram image={image} markers={markers} />
        </Stack>
    </Card>
}